<template>
  <div class="banner-mt-link">
    <div
      v-if="isMobile"
      class="banner-mt-link__strip banner-mt-link__strip--stacked"
      @click="openModal"
    >
      <div>
        <img
          class="banner-mt-link__logo banner-mt-link__logo--stacked"
          :src="logoSrc"
          :alt="translate('Логотип МедТочки')"
        >
        <div class="text-body-2">
          {{ text }}
        </div>
      </div>
      <div class="ml-3">
        <span class="ui-icon-circle-info" />
      </div>
    </div>
    <div
      v-else
      class="banner-mt-link__strip"
      @click="openModal"
    >
      <img
        class="banner-mt-link__logo mr-8"
        :src="logoSrc"
        :alt="translate('Логотип МедТочки')"
      >
      <div class="text-body-2 mr-3">
        {{ text }}
      </div>
      <span class="ui-icon-circle-info ml-auto" />
    </div>

    <BannerMtLinkModal
      v-if="isOpened"
      @close="isOpened = false"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import i18next from 'i18next'
import useIsMobile from 'src/composables/useIsMobile'
import useYandexGoals from 'src/composables/useYandexGoals'
import useContextStore from 'src/store/useContextStore'
import type { CommonContextStore } from 'src/types/context'
import BannerMtLinkModal from 'src/components/common/BannerMtLink/components/BannerMtLinkModal.vue'

defineProps<{
  text: string
}>()

const { t, language } = i18next
const l10nOptions = { ns: language }
const translate = (key: string) => t(key, l10nOptions) || key
const isMobile = useIsMobile()
const { context }: CommonContextStore = useContextStore()
const { sendYaGoal } = useYandexGoals()
const isOpened = ref(false)
const staticSrc = computed(() => context.global?.static?.src || '/static/')
const logoSrc = computed(() => `${staticSrc.value}_v1/pd/logos/ui-kit/medtochka-logo.svg`)

function openModal() {
  isOpened.value = true
  sendYaGoal('mtlinkModal__open')
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.banner-mt-link {
  &__strip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-radius: $border-radius-sm;
    background-color: $ui-kit-bg-secondary;
    color: $ui-kit-primary;
    box-shadow: 0 15px 20px rgba(#979EA7, 0.1);
    cursor: pointer;
  }

  &__strip--stacked {
    padding: 16px;
  }

  &__logo {
    max-width: 84px;
  }

  &__logo--stacked {
    margin-bottom: 8px;
  }
}
</style>
